import { Controller } from "@hotwired/stimulus";
import { EditorView, basicSetup } from "codemirror";
import { html } from "@codemirror/lang-html";
import { liquid } from "@codemirror/lang-liquid";

export default class extends Controller {
  static targets = ["templateEditor", "source"];
  static values = { saveUrl: String };

  connect() {
    console.log("template editor");
    this.codeMirrorView = new EditorView({
      doc: this.sourceTarget.value,
      extensions: [basicSetup, html(), liquid()],
      parent: this.templateEditorTarget,
      dispatch: this.templateEditorUpdated.bind(this),
    });
  }

  templateEditorUpdated(transaction) {
    this.codeMirrorView.update([transaction]);
  }

  saveTemplate() {
    console.log("saveTemplate");
    let formData = new FormData();
    formData.append(
      "liquid_template[html]",
      this.codeMirrorView.state.doc.toString()
    );
    fetch(this.saveUrlValue, {
      body: formData,
      method: "PATCH",
      credentials: "include",
      headers: {
        "X-CSRF-Token": getMetaValue("csrf-token"),
      },
    }).then(function (response) {
      console.log(response.status);
      console.log(response);
    });
  }
}

function getMetaValue(name) {
  const element = document.head.querySelector(`meta[name="${name}"]`);
  return element.getAttribute("content");
}
